import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { solicitarAtivacao2FA } from "./services";
import { toast } from "sonner";

interface Setup2FAData {
  qrCodeImageUrl: string;
  manualEntryKey: string;
}

interface Ativar2FAState {
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
  setupData: Setup2FAData | null;
}

const initialState: Ativar2FAState = {
  status: "idle",
  error: null,
  setupData: null,
};

export const ativar2FA = createAsyncThunk<
  Setup2FAData,
  void,
  { rejectValue: string }
>("auth/ativar2FA", async (_, { rejectWithValue }) => {
  try {
    const data = await solicitarAtivacao2FA();
    return data;
  } catch (err: any) {
    const errorMessage =
      err.response?.data?.message || "Falha ao gerar os dados do 2FA.";
    return rejectWithValue(errorMessage);
  }
});

const ativar2faSlice = createSlice({
  name: "ativar2fa",
  initialState,
  reducers: {
    resetAtivar2FAState: (state) => {
      state.status = "idle";
      state.error = null;
      state.setupData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ativar2FA.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.setupData = null;
      })
      .addCase(
        ativar2FA.fulfilled,
        (state, action: PayloadAction<Setup2FAData>) => {
          state.status = "success";
          state.setupData = action.payload;
        },
      )
      .addCase(
        ativar2FA.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Ocorreu um erro inesperado.";
        },
      );
  },
});

export const { resetAtivar2FAState } = ativar2faSlice.actions;
export default ativar2faSlice.reducer;
